export const HttpResponseStatus = Object.freeze({
  OK: "EXITO",
  ERROR: "ERROR",
});
